import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { isOperator, isNotOperator } from '../../../../../filters/operators/collection';
import { emptyArray } from 'ui-components/default-props/empty';
import Global from '../../../../../store/global-selectors';
import { noop } from 'ui-components/default-props/noop';
import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';

import style from '../../../../../services/filtering/filter-form-render-service/common.module.less';

const domesticId = 'domestic';
const internationalId = 'international';

const defaultCriteriaInformation = {
  criterionStateMethods: {
    getCriterionOperator: noop,
    updateCriterionArgument: noop,
    updateCriterionOperator: noop,
  },
  criterionArgumentOptions: emptyArray,
};

export const DestinationComponent = ({ criteriaInformations = defaultCriteriaInformation }) => {
  const { criterionStateMethods, criterionArgumentOptions } = criteriaInformations;
  const sellerHomeCountry = useSelector(Global.selectSellerHomeCountry);
  const { updateCriterionArgument, updateCriterionOperator, getCriterionOperator } = criterionStateMethods;
  const selectedId = getCriterionOperator()?.value === isOperator.name ? domesticId : internationalId;

  useEffect(() => {
    updateCriterionArgument({ value: sellerHomeCountry });
  }, [sellerHomeCountry, updateCriterionArgument]);

  return (
    <div className={style['form-criteria-section']}>
      <RadioCheckList>
        {criterionArgumentOptions.map((option) => {
          const optionDisplayName = option.displayName;
          const { id } = option;
          return (
            <RadioCheckListItem
              key={option.id}
              isChecked={id === selectedId}
              onChecked={() => {
                if (id === internationalId) {
                  updateCriterionOperator({ value: isNotOperator.name });
                } else updateCriterionOperator({ value: isOperator.name });
              }}
            >
              {optionDisplayName}
            </RadioCheckListItem>
          );
        })}
      </RadioCheckList>
    </div>
  );
};

DestinationComponent.propTypes = {
  criteriaInformations: PropTypes.shape({
    criterionStateMethods: PropTypes.shape({
      getCriterionOperator: PropTypes.func,
      updateCriterionArgument: PropTypes.func,
      updateCriterionOperator: PropTypes.func,
    }),
    criterionArgumentOptions: PropTypes.array,
  }),
};
